import { initReactI18next } from "react-i18next";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { BRAND_NAME } from "@/shared/config/brand";
import { runtimeConfig } from "@/shared/config/runtime";
import { syncDocumentLanguage } from "./documentLanguage";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "ru",
    supportedLngs: ["ru", "kk", "en"],
    preload: ["ru", "kk"],
    ns: ["Common"],
    defaultNS: "Common",
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
      defaultVariables: { brand: BRAND_NAME },
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag", "path", "subdomain"],
      caches: ["localStorage"],
    },
  });

if (typeof window !== "undefined") {
  i18n.on("languageChanged", syncDocumentLanguage);
  i18n.on("initialized", () => {
    syncDocumentLanguage(i18n.language);
    i18n
      .loadNamespaces([
        "AccessibilityPanel",
        "ErrorBoundary",
        ...(runtimeConfig.isDemo || runtimeConfig.useMockApi ? ["DemoPage"] : []),
      ])
      .catch(() => {});
  });
}

export default i18n;
